import { WhatsNewArea } from "@btnet/services-btnet/handlers/models/whatsNewArea";

/** Areas arrive as numbers, so labels live here. */
const areaLabels: Record<WhatsNewArea, string> = {
    [WhatsNewArea.General]: "General",
    [WhatsNewArea.Sales]: "Sales",
    [WhatsNewArea.ProjectManagement]: "Project Management",
    [WhatsNewArea.Financial]: "Financial",
    [WhatsNewArea.Communication]: "Communication",
    [WhatsNewArea.Settings]: "Settings",
};

/** Every area an author can choose, in the order the C# enum declares them. */
export const whatsNewAreas: WhatsNewArea[] = Object.values(WhatsNewArea);

/** Falls back to General so a retired or newer-than-this-bundle area is never a blank pill. */
export function getWhatsNewAreaLabel(area: WhatsNewArea): string {
    return areaLabels[area] ?? "General";
}

/** Shown when an author supplies a link URL but no wording for it. */
export const defaultCtaLabel = "Learn more";

/** Client mirror of the server's http/https check. Lenient on purpose: the server decides. */
export function isAbsoluteHttpUrl(value: string): boolean {
    // The URL parser fills in missing slashes (`http:foo.com`), so check the prefix first.
    if (!/^https?:\/\/[^/]/i.test(value)) {
        return false;
    }

    try {
        const url = new URL(value);
        // .NET rejects an empty label (`foo..com`) but accepts a trailing dot.
        const hasEmptyLabel = url.hostname.replace(/\.$/, "").split(".").includes("");
        return (url.protocol === "http:" || url.protocol === "https:") && !hasEmptyLabel;
    } catch {
        return false;
    }
}

const appHost = "buildertrend.net";

/** True only for the app itself. Subdomains (help centre, learn, other environments) are separate sites. */
export function isInternalUrl(url: string): boolean {
    try {
        return new URL(url).hostname.toLowerCase() === appHost;
    } catch {
        return false;
    }
}
